<div class="row mt-3 mr-1 ml-1">
	<div class="col-md-12" align="center">
		<h3>PROGRAM</h3>

		<p>
			All events take place at <a target="_blank" href="https://www.consob.it/">CONSOB</a> headoffice, Via Giovanni Battista Martini, 3 - 00198 Rome (Italy).
		</p>

		<table width="100%" cellspacing="2" cellpadding="2">
			<tr>
				<td></td>
			</tr>
			<tr bgcolor="lightblue">
				<td class="schedule" colspan="2">
					<br>
				</td>
			</tr>
			<tr><td colspan="2"><br></td></tr>
			<tr>
				<td class="schedule"></td>
				<td>
					<font size="+1">
						<a href="https://www.consob.it/documents/1912911/2058255/20231214-15_CIFRIS23.pdf/0651a612-66c6-a225-707d-ad5d91f40064">Locandina Istituzionale</a>
					</font> <br>
					<font size="+1">
						<a href="https://drive.google.com/file/d/1T6MYqf8NC-4vjLXUmRJxfui_8Gu4grPG/view?usp=drive_link">Proceedings</a>
					</font>
				</td>
			</tr>
			<tr><td colspan="2"><br></td></tr>
			<tr bgcolor="lightblue">
				<td class="schedule" colspan="2">
					<font size="+1"><b>14 December (morning) - Institutional Session</b></font>
				</td>
			</tr>
			<tr><td colspan="2"><br></td></tr>
			<tr>
				<td class="schedule">8:30-10:00</td>
				<td><em>Registration</em></td>
			</tr>
			<tr>
				<td class="schedule"></td>
				<td>
					<p>
						<u>Servizio televisivo</u>: <a href="https://media.datastampa.it/media/20231216/20231216-CLASS_CNBC-SPECIALE_CLASS_CNBC_1615-165821525m.mp4">SPECIALE CLASS CNBC</a>
					</p>
				</td>
			</tr>
			<tr><td colspan="2"><hr></td></tr><!------------------------------>
			<tr>
				<td class="schedule">10:00-10:30</td>
				<td>
					<em>Welcome address</em> - <a href="https://youtu.be/cJuwbeHzDVU?si=Fee4EWZ0pffyBO_Q">Video</a> <br>
				</td>
			</tr>
			<tr>
				<td class="schedule"></td>
				<td>
					<em>Speakers</em> :
					Paolo Savona (<a target="_blank" href="https://www.consob.it/">CONSOB</a>'s President) and Massimiliano Sala (De Cifris' President) 
				</td>
			</tr>
			<tr><td colspan="2"><hr></td></tr><!------------------------------>
			<tr>
				<td class="schedule">10:30-11:30</td>
				<td>
					<b>Institutional Round Table</b> - <a href="https://www.youtube.com/live/CMJwXiZxITE?si=yemmkDkULxfZZpEN">Video</a> <br>
				</td>
			</tr>
			<tr>
				<td class="schedule"></td>
				<td>
					<u>Moderator</u>: Francesca Medda (CONSOB) <br>
					<u>Confirmed speakers</u>:
					<ul>
						<li>
							Paolo Aceto, Generale, Arma dei Carabinieri
						</li>

						<li>
							Pietro Bianchi, Generale, Guardia di Finanza
						</li>

						<li>
							Andrea Billet, Direttore Servizio, Agenzia per la Cybersicurezza Nazionale
						</li>

						<li>
							Ivano Gabrielli, Direttore Polizia Postale, Ministero degli Interni
						</li>
					</ul>
				</td>
			</tr>
			<tr><td colspan="2"><hr></td></tr>
			 <tr>
				<td class="schedule">11:30-12:00</td>
				<td><em>Coffee break</em><br>
				</td>
			 </tr>
			 <tr><td colspan="2"><hr></td></tr>
			 <tr>
				<td class="schedule">12:00-12:30</td>
				<td><b>Invited Talk</b><br></td>
			</tr>
			<tr>
				<td class="schedule"></td>
				<td>
					<em>Massimo Giulietti (University of Perugia - Italy)</em> - <a href="https://drive.google.com/file/d/1fCIeC_FFjrtgZj_wQpeWUMUV8hDTEaF0/view?usp=drive_link">Slide</a> <br>
					"Cryptography and its applications in the Italian scenario"
				</td>
			 </tr>
			 <tr><td colspan="2"><hr></td></tr>
			<tr>
				<td class="schedule">12:30-13:00</td>
				<td>
					<b>De Cifris Partners</b>
				</td>
			</tr>
			<tr>
				<td class="schedule"></td>
				<td>	
					<em>Antonino Giovanni ALÌ</em> (De Componendis Cifris) - 
					<span
						class="popup"
						targetId="abstractAli"
						(click)="openPopup($event)"
					>
						Abstract
						<span class="popuptext" id="abstractAli">
							In questa sessione viene presentata l’Associazione De Componendis Cifris e gli obiettivi che essa si prefigge, tra cui l’uso della crittografia a servizio del nostro paese tramite la collaborazione dell’Associazione con le istituzioni e il settore privato nel tentativo di promuovere lo studio e la ricerca del settore crittografico in Italia. In particolare ascolteremo le due aziende affiliate a De Cifris: Telsy e BVTech.
						</span>
					</span><br>
					"La visione di De Cifris per le partnership con le aziende leader"
				</td>
			</tr>
			<tr><td colspan="2"><br></td></tr>
			<tr>
				<td class="schedule"></td>
				<td>	
					<em>Vincenzo MAFRICA</em> (Direttore Business Unit di BVTECH) - <a href="https://docs.google.com/presentation/d/1HVYXypE4_xgchC4uVjfYDg-niIQaqkKD/edit?usp=drive_link">Slide</a> -
					<span
						class="popup"
						targetId="abstractMafrica"
						(click)="openPopup($event)"
					>
						Abstract
						<span class="popuptext" id="abstractMafrica">
							In questa sessione viene presentata BVTech, un’azienda che da vent’anni si occupa di garantire la sicurezza dei dati e delle informazioni tramite la collaborazione con aziende ed istituzioni, con un approccio dedito ad anticipare i cambiamenti delle telecomunicazioni. Inoltre, viene presentata Privatewave, un prodotto made in Italy che si pone come soluzione per una comunicazione sicura. Si basa sull’uso di protocolli standard di cifratura e sull’utilizzo di componenti software open source capaci di proteggere il contenuto delle conversazioni telefoniche in tutte le sue forme.
						</span>
					</span><br>
					"La crittografia nelle comunicazioni sicure: l’esperienza BV TECH"
				</td>
			</tr>
			<tr><td colspan="2"><br></td></tr>
			<tr>
				<td class="schedule"></td>
				<td>	
					<em>Guglielmo MORGARI</em> (Research Manager di TELSY) -
					<span
						class="popup"
						targetId="abstractMorgari"
						(click)="openPopup($event)"
					>
						Abstract
						<span class="popuptext" id="abstractMorgari">
							In questa sessione viene presentata Tesly, un’azienda presente sul territorio dal 1971. Viene sottolineata l’importanza per Tesly dell’indipendenza tecnologica, le cui competenze consentono ai singoli Stati di trovare il giusto equilibrio tra sicurezza, economicità, funzionalità e così via. La tecnologia risulta inoltre utile a indirizzare i Paesi verso valori e aspettative sociali peculiari di ciascuno, a fronte di ciò Tesly riconosce l’importanza di DeCifris nel contesto nazionale come punto di coordinamento delle diverse competenze.
						</span>
					</span><br>
					"Il ruolo strategico della crittografia nel conseguimento della sovranità tecnologica nazionale"
				</td>
			</tr>
			<tr><td colspan="2"><hr></td></tr><!------------------------------>
			<tr>
				<td class="schedule">13:00-14:30</td>
				<td><em>Lunch</em><br>
				</td>
			</tr>
			<tr><td colspan="2"><br></td></tr>
			 
			<tr bgcolor="lightblue">
				<td class="schedule" colspan="2">
				  <font size="+1"><b>14 December (afternoon) - Scientific Session</b></font>
				</td>
			</tr>
			<tr><td colspan="2"><br></td></tr>
			<tr>
				<td class="schedule">14:30-16:30</td>
				<td>
					<b>Mini-session: Number theory and cryptography</b> - <a href="https://www.youtube.com/live/Do3ZLHEn67o?si=1VGEFJeWILrOg77s">Video</a> <br>
				</td>
			</tr>
			<tr>
				<td class="schedule"></td>
				<td>
					<p>
						<em><b>Invited Talk</b> - Antoine Joux (CISPA - Germany), winner of the Goedel price</em> - <a href="https://drive.google.com/file/d/1En_0ECwux9bhN5GdJUqhDPfkL9-WRxT7/view?usp=drive_link">Slide</a> <br>
						"MPC in the head for isomorphisms and group action" - 
						<span
							class="popup"
							targetId="abstract1"
							(click)="openPopup($event)"
						>
							Abstract
							<span class="popuptext" id="abstract1">
								In this talk, we give a tutorial about MPC-in-the-head for signature schemes and illustrate it by designing identification protocols and signature schemes from group actions. We discuss the security of the proposed identification schemes and rely on the Fiat-Shamir transformation to turn them into signatures. We also stress that an essential ingredient for the efficiency of such signature schemes is the use of Puncturable-PRFs.
							</span>
						</span>
					</p>

		 			<!--
		 			<button 
						class="read-more"
						targetId="abstract0"
						(click)="readMoreHandler($event)"
					>
						Read more
					</button>
					-->
				</td>
			</tr>
			<tr>
				<td class="schedule"></td>
				<td>
					<em>Wissam Ghantous, Federico Pintore and Mattia Veroni</em> - <a href="https://drive.google.com/file/d/1izXnn8gLolZ9VVHtWtpwA5SOEomW19Rg/view?usp=drive_link">Slide</a> <br>
					"Efficiency of SIDH-based signatures (yes, SIDH)"
				</td>
			</tr>
			<tr><td colspan="2"><br></td></tr>
			<tr>
				<td class="schedule"></td>
				<td>
					<em>Massimiliano Sala and Daniele Taufer</em> - <a href="https://drive.google.com/file/d/1vmH_FzCbWbJ2AuMCUVdXsS0WEIJpRZ_l/view?usp=drive_link">Slide</a> <br>
					"The group structure of elliptic curves over Z/NZ"
				</td>
			</tr>
			<tr><td colspan="2"><hr></td></tr><!------------------------------>
			<tr>
				<td class="schedule">16:30-17:00</td>
				<td><em>Coffee break</em></td>
			</tr>
			<tr><td colspan="2"><hr></td></tr><!------------------------------>
			<tr>
				<td class="schedule">17:00-19:00</td>
				<td><b>Mini-session: Between theory and practice</b><br></td>
			</tr>
			<tr>
				<td class="schedule"></td>
				<td>
					<em>Kaveh Aasaraai, Emanuele Cesena, Rahul Maganti, Nicolas Stalder and Javier Varela</em> - <a href="https://drive.google.com/file/d/1b5FbD4NLZFCaA4unina2fKXu8DDlEb4F/view?usp=drive_link">Slide</a> <br>
					"FPGA And Software Acceleration of Multi-Scalar Multiplication: CycloneMSM"
				</td>
			</tr>
			<tr><td colspan="2"><br></td></tr>
			<tr>
				<td class="schedule"></td>
				<td>
					<em>Márton Erdélyi, Pál Hegedüs, Sándor Kiss and Gábor Nagy</em> - <a href="https://drive.google.com/file/d/1QJDKKR0bViH8ucBZwy_TKlXRq87_c-jP/view?usp=drive_link">Slide</a> <br>
					"On Linear Codes with Random Multiplier Vectors and the Maximum Trace Dimension Property"
				</td>
			</tr>
			<tr><td colspan="2"><br></td></tr>
			<tr>
				<td class="schedule"></td>
				<td>
					<em>Marco Timpanella</em> - <a href="https://drive.google.com/file/d/10P491fh5P8XlUbMATGgemobygPrsbKxq/view?usp=drive_link">Slide</a> <br>
					"On a generalization of the Deligne-Lustzig curve of Suzuki type and application to AG codes"
				</td>
			</tr>
			<tr><td colspan="2"><br></td></tr>
			<tr>
				<td class="schedule"></td>
				<td>
					<em>Kyosuke Yamashita and Keisuke Hara</em> - <a href="https://docs.google.com/presentation/d/1a7OFhCyJwvJDdaFeofeML-x_hLAdaNs3/edit?usp=drive_link">Slide</a> <br>
					"On the Black-Box Impossibility of Multi-Designated Verifiers Signature Schemes from Ring Signature Schemes"
				</td>
			</tr>
			<tr><td colspan="2"><hr></td></tr>
			<tr>
				<td class="schedule">21:00</td>
				<td><em>Social Dinner</em></td>
			</tr>
			<tr>
				<td class="schedule"></td>
				<td>
					Location: <a href="https://www.marriott.com/en-us/hotels/rommd-le-meridien-visconti-rome">
						Le Meridien Visconti Rome
					</a>
				</td>
			</tr>
			<tr><td colspan="2"><br></td></tr>

			<!---------------------------------------------------------------->

			<tr bgcolor="lightblue">
				<td class="schedule" colspan="2">
					<font size="+1">
						<b>15 December (morning) - Workshop Session</b>
					</font>
				</td>
			</tr>
			<tr><td colspan="2"><br></td></tr>
			<tr>
				<td colspan="2">
					<h4>Main Hall</h4>
				</td>
			</tr>
			<tr><td colspan="2"><hr></td></tr><!------------------------------>
			<tr>
				<td class="schedule">9:00-11:00</td>
				<td>
					<b>Workshop</b> - <a href="https://www.youtube.com/live/UxTXFg8Wv5s?si=MjnzEm4swBdClDIG">Video</a>
				</td>
			</tr>
			<tr>
		 		<td class="schedule"></td>
		 		<td>
		 			<p>
		 				<em>Synthetic Data,  Cyber Security and Finance</em> <br>
		 				<u>Organizer</u> : Francesca Medda
		 			</p>
			 		<p>
		 				<u>Invited speakers from</u> : <em>
		 					<b>European Commission</b>, <b>Banca D'Italia</b>, <b>CONSOB</b>, <b>University of Oxford</b>
		 				</em> <br>
					</p>
			 		<ul>
			 			<li>
			 				<em>Alice Guedel</em> and <em>Andrea Pagano</em>
			 			</li>

			 			<li>
			 				<em>Mariarosaria Taddeo</em>
			 			</li>

			 			<li>
			 				<em>Marco Benedetti</em> and <em>Andrea Coletta</em>
			 			</li>

			 			<li>
			 				<em>Francesca Medda</em>
			 			</li>
			 		</ul>
				</td>
			</tr>
			<tr><td colspan="2"><hr></td></tr><!------------------------------>
			<tr>
		 		<td class="schedule">11:00-11:30</td>
		 		<td>
		 			<em>Coffee break</em>
				</td>
			</tr>
			<tr><td colspan="2"><hr></td></tr><!------------------------------>
			<tr>
				<td class="schedule">11:30-13:30</td>
				<td>
					<b>Workshop</b> - <a href="https://www.youtube.com/live/UxTXFg8Wv5s?si=MjnzEm4swBdClDIG">Video</a>
				</td>
			</tr>
			<tr>
		 		<td class="schedule"></td>
		 		<td style="width: 90%">
		 			<p>
		 				<em>CBDCs, Digital Currencies and Assets Tokenization: opportunities and risks</em> - 
						<span
							class="popup"
							targetId="abstract2"
							(click)="openPopup($event)"
						>
							Abstract
							<span class="popuptext" id="abstract2">
								CBDCs promise large-scale efficiency but also pose significant challenges, including potential centralization and control unprecedented in the financial sector. This workshop aims to foster a rich dialogue on the opportunities and risks associated with CBDCs, digital currencies, and tokenization of assets focusing on both national and international perspectives.
							</span>
						</span> <br>
		 				<u>Organizers</u> : Andrea Bracciali, Davide Carboni 
		 			</p>
			 		<p>
			 			<u>Invited speaker from</u> : <em>
			 				<b>CONSOB</b>
			 			</em><br>
			 			Open discussion with panelists:
			 		</p>
			 		<ul>
			 			<li>
			 				<em>Gianfranco Trovatore</em> - <a href="https://www.youtube.com/live/UxTXFg8Wv5s?si=s0mn4S53YNT6sM2C&t=9355">Slide</a>
			 			</li>

			 			<li>
			 				<em>Vincenzo Vespri</em> and <em>Filippo Zatti</em> - <a href="https://docs.google.com/presentation/d/1Idmj9YYUemdXO3oKpWO6cnUffUWXRTE6/edit?usp=drive_link&ouid=100146400917419159025&rtpof=true&sd=true">Slide</a>
			 			</li>

			 			<li>
			 				<em>Guneet Kaur</em> - <a href="https://docs.google.com/presentation/d/1ZubLMaFOtv0OrS-DAsPccMqIyxJS5KPB/edit?usp=drive_link&ouid=100146400917419159025&rtpof=true&sd=true">Slide</a>
			 			</li>

			 			<li>
			 				<em>Daniel Broby</em> - <a href="https://drive.google.com/file/d/1Bdy6fHXy0sikdTaN8aRNFpPk4AcSevvH/view?usp=drive_link">Slide</a>
			 			</li>

			 			<li>
			 				<em>Andrea Bracciali, Geoff Goodell</em> and <em>Giorgio Gasparri</em> - <a href="https://www.youtube.com/live/UxTXFg8Wv5s?si=s0mn4S53YNT6sM2C&t=13510">Slide</a>
			 			</li>
			 		</ul>
					<p>
			 			Information and call for papers can be found <a href="https://sites.google.com/view/cifrisinnovation23/">here</a>.
					</p>
		 		</td>
			</tr>
			<tr><td colspan="2"><hr></td></tr><!------------------------------>

			<tr>
				<td colspan="2">
					<h4>Room A</h4>
				</td>
			</tr>
			<tr><td colspan="2"><hr></td></tr><!------------------------------>
			<tr>
				<td class="schedule">9:00-11:00</td>
				<td>
					<b>Workshop</b> - <a href="https://www.youtube.com/live/UxTXFg8Wv5s?si=MjnzEm4swBdClDIG">Video</a>
				</td>
			</tr>
			<tr>
		 		<td class="schedule"></td>
		 		<td style="width: 90%">
		 			<p>
		 				<em>Recent Advances in Post-Quantum Cryptography</em> - 
						<span
							class="popup"
							targetId="abstract3"
							(click)="openPopup($event)"
						>
							Abstract
							<span class="popuptext" id="abstract3">
								Post-quantum cryptography, the study of cryptosystems capable of withstanding both classical and quantum attacks, is a timely area of research, as proven by the standardization effort led by NIST. Recently the focus has been on digital signature schemes, which are the subject of the latest NIST competition. <br>
		 						This workshop will provide an overview of the state of the art in post-quantum cryptography with a focus on cutting-edge methods for designing and implementing post-quantum signature schemes.
							</span>
						</span> <br>
		 				<u>Organizers</u> : Marco Baldi, Giulio Codogni, Roberto La Scala, Alessio Meneghetti, Gerardo Pelosi, Federico Pintore
		 			</p>
		 			<p>
		 				<u>Invited speaker</u> : <em>
		 					<b>Luca De Feo</b>
		 				</em>
		 			</p>	
					<ul>
						<li>
							<em>Luca De Feo</em> - <a href="https://drive.google.com/file/d/1w67nlLvDJSTSi2cDHNYZ1CmE7NGrdnPV/view?usp=drive_link">Slide</a> <br>
			 				"SQIsign, the new herald of isogeny based crypto"
						</li>

						<li>
							<em>Krijn Reijnder</em> - <a href="https://drive.google.com/file/d/12b8MqH4emL5P6bEEkwoEH2nlZP0r5Qqu/view?usp=drive_link">Slide</a> <br>
			 				"MCE and MEDS: From Group Actions to Signatures"
						</li>

						<li>
							<em>Paolo Santini</em> - <a href="https://drive.google.com/file/d/1mHHA25RGH51xcHkMiGxfJMyf4w_MllMf/view?usp=drive_link">Slide</a> <br>
			 				"Signatures from Five-Pass Zero-Knowledge Protocols and the Curious Case of CROSS"
						</li>

						<li>
							<em>Alessandro Barenghi</em> - <a href="https://drive.google.com/file/d/1RhkM9Q3Kx39CiVQzLnmFV06PnIIhuY4e/view?usp=drive_link">Slide</a> <br>
			 				"No one should learn from these errors: surveying fault attack resistance of post quantum cryptosystems"
						</li>
					</ul>
				</td>
			</tr>
			<tr><td colspan="2"><hr></td></tr><!------------------------------>
			<tr>
		 		<td class="schedule">11:00-11:30</td>
		 		<td>
		 			<em>Coffee break</em>
				</td>
			</tr>
			<tr><td colspan="2"><hr></td></tr><!------------------------------>
			<tr>
				<td class="schedule">11:30-13:30</td>
				<td>
					<b>Workshop</b> - <a href="https://www.youtube.com/live/UxTXFg8Wv5s?si=MjnzEm4swBdClDIG">Video</a>
				</td>
			</tr>
			<tr>
		 		<td class="schedule"></td>
		 		<td style="width: 90%">
		 			<p>
		 				<em>Topics in Applied Cryptography</em> - 
						<span
							class="popup"
							targetId="abstract4"
							(click)="openPopup($event)"
						>
							Abstract
							<span class="popuptext" id="abstract4">
								This workshop is dedicated to cryptography with a specific application, scenario and/or technology in mind, including performance evaluation, libraries and implementation issues, hardware and IoT, attacks and vulnerabilities, and requirements for unusual application scenarios. Topics of interest include privacy enhancing cryptography, homomorphic encryption, secure multi-party computation, quantum key distribution, and quantum-safe cryptography. [<a href="https://easychair.org/cfp/TAC2023">Call for Papers</a>]
							</span>
						</span> <br>
		 				<u>Organizers</u> : Silvio Ranise, Alessandro Tomasi, D’Intino Andrea, Roio Denis
		 			</p>
			 		<p>
			 			<u>Invited speaker</u> : <em>
			 				<b>Marco Baldi</b>
			 			</em>
			 		</p>
			 		<ul>
			 			<li>
			 				<em>Marco Baldi</em> - <a href="https://drive.google.com/file/d/1VScT9XPQTlM0WJXqZ2BfvGMNHMuPLIOG/view?usp=drive_link">Slide</a> <br>
			 				"Royal Rumbles in Cryptography: the NIST PQC Competition"
			 			</li>

			 			<li>
			 				<em>Stefano Berlato, Alessandro Colombo, Roberto Carbone </em> and <em>Silvio Ranise</em> - <a href="https://drive.google.com/file/d/1mbmWxUzFxxYinoJ2wifXx81RR4UmVmKr/view?usp=drive_link">Slide</a> <br>
			 				"Cryptographic Enforcement of Attribute-based Access Control Policies"
			 			</li>

			 			<li>
			 				<em>Stefano Berlato, Roberto Carbone</em> and <em>Silvio Ranise</em> - <a href="https://drive.google.com/file/d/1mbmWxUzFxxYinoJ2wifXx81RR4UmVmKr/view?usp=drive_link">Slide</a> <br>
			 				"OpenABE Bindings for Kotlin"
			 			</li>

			 			<li>
			 				<em>Chiara Spadafora, Michele Battagliola, Giuseppe D'Alconzo</em> and <em>Andrea Gangemi</em> - <a href="https://drive.google.com/file/d/1kxqGSX0w1R8g2U33aInlE2IuxZ1kcESE/view?usp=drive_link">Slide</a> <br>
			 				"Multiparty Class Group Encryption and Applications to E-Voting"
			 			</li>

			 			<li>
			 				<em>Chiara Spadafora, Riccardo Longo</em> and <em>Francesco Antonio Marino</em> - <a href="https://drive.google.com/file/d/1rhLrwwz3sZdRZK_DzuB1RB_0OJDufqh9/view?usp=drive_link ">Slide</a> <br>
			 				"Vote App: Verifiable and Coercion-Resistant I-Voting"
			 			</li>

			 			<li>
			 				<em>Andrea D'Intino</em> and <em>Denis Roio</em> - <a href="https://docs.google.com/presentation/d/1OafYXpWMVi-RlFYug9yYDlmQYphwAYYv/edit?usp=drive_link&ouid=104443972368938218642&rtpof=true&sd=true">Slide</a> <br>
			 				"Rapid implementation and deployment of cryptographic flows"
			 			</li>
			 		</ul>
		 		</td>
			</tr>
			<tr><td colspan="2"><hr></td></tr><!------------------------------>

			<tr>
				<td colspan="2">
					<h4>Room B</h4>
				</td>
			</tr>
			<tr><td colspan="2"><hr></td></tr><!------------------------------>
			<tr>
				<td class="schedule">9:00-11:00</td>
				<td>
					<b>Workshop</b> - <a href="https://www.youtube.com/live/UxTXFg8Wv5s?si=MjnzEm4swBdClDIG">Video</a>
				</td>
			</tr>
			<tr>
		 		<td class="schedule"></td>
		 		<td style="width: 90%">
		 			<p>
		 				<em>Privacy-preserving Machine Learning Workshop</em> - 
						<span
							class="popup"
							targetId="abstract5"
							(click)="openPopup($event)"
						>
							Abstract
							<span class="popuptext" id="abstract5">
								Privacy-preserving machine learning is a vital field as organizations and individuals strive to leverage machine learning while safeguarding sensitive data. The workshop addresses a growing demand for privacy enhancing techniques. It offers an up-to-date overview of the key concepts, methods, and tools. <br>
		 						With a keynote on Fully Homomorphic Encryption (FHE) by Andrei Stoian from Zama Concrete-ML and contributions from various experts focusing on topics such as Differential Privacy, Federated Learning, FHE, Secure Multi-Party Computation, and Trusted Execution Environment.
							</span>
						</span> <br>
		 				<u>Organizers</u> : Marco Pedicini, Michela Iezzi
		 			</p>
		 			<p>
		 				<u>Invited speaker</u> : <em>
		 					<b>Andrei Stoian</b>
		 				</em>
			 		</p>
			 		<ul>
			 			<li>
			 				<em>Andrei Stoian</em> - <a href="https://drive.google.com/file/d/15E3oMBNE4hVk7FAFqKhyOPXZ67q1ws2z/view">Slide</a> <br>
			 				"Privacy-preserving Machine Learning Workshop"
			 			</li>

			 			<li>
			 				<em>Valerio Maggio</em> - <a href="https://drive.google.com/file/d/1JO40mndKE4EzfVTFUywbzdxLEo0rmNKE/view?usp=drive_link">Slide</a> <br>
			 				"PPML, Machine learning on data you cannot see"
			 			</li>
			 		</ul>
					<p>
			 			Information and call for papers can be found <a href="http://logica.uniroma3.it/PPML">here</a>.
					</p>
				</td>
			</tr>
			<tr><td colspan="2"><hr></td></tr><!------------------------------>
			<tr>
		 		<td class="schedule">11:00-11:30</td>
		 		<td>
		 			<em>Coffee break</em>
				</td>
			</tr>
			<tr><td colspan="2"><hr></td></tr><!------------------------------>
			<tr>
				<td class="schedule">11:30-13:30</td>
				<td>
					<b>Workshop</b> - <a href="https://www.youtube.com/live/UxTXFg8Wv5s?si=MjnzEm4swBdClDIG">Video</a>
				</td>
			</tr>
			<tr>
		 		<td class="schedule"></td>
		 		<td style="width: 90%">
		 			<p>
		 				<em>New trends in Group-Based Cryptography</em> - 
						<span
							class="popup"
							targetId="abstract6"
							(click)="openPopup($event)"
						>
							Abstract
							<span class="popuptext" id="abstract6">
								Group theory, particularly non-abelian groups, provides a wealth of challenges for cryptography, introducing a novel dimension to this field. <br>
		 						The objective of this workshop is to offer an up-to-date overview of the current state of group-based cryptography and to present recent developments. More precisely, the workshop will focus on computational group theory, suitable platform groups, and potential intersections between them.
							</span>
						</span> <br>
		 				<u>Organizers</u> : Norberto Gavioli, Carmine Monetta, Marialaura Noce
		 			</p>
		 			<p>
		 				<u>Invited speaker</u> : <em>
		 					<b>Delaram Kahrobaei</b>
		 				</em>
					</p>
					<ul>
						<li>
							<em>Delaram Kahrobaei</em> - <a href="https://drive.google.com/file/d/1Jq6iIbnBwrbjGq7WbeDE_X8LKHp-a0Vw/view">Slide</a> <br>
			 				"A Subexponential Quantum Algorithm for the Semidirect Discrete Logarithm Problem and SPDH-Sign: towards Efficient, Post-quantum Group-based Signatures"
						</li>

						<li>
							<em>Riccardo Aragona</em> - <a href="https://drive.google.com/file/d/1zK3BAwBlKVheCQix8ncpVapBduSnJY1U/view?usp=drive_link">Slide</a> <br>
			 				"Some results on the groups generated by round functions"
						</li>

						<li>
							<em>Ramon Flores</em> - <a href="https://drive.google.com/file/d/17X6YEyLo29pXr5mYI7KOH3dE7IzFqyEQ/view?usp=drive_link">Slide</a> <br>
			 				"Groups and cryptography"
						</li>

						<li>
							<em>Antonio Tortora</em> <br>
			 				"A “smart” application of homomorphic encryption"
						</li>

						<li>
							<em>Martina Vigorito</em> - <a href="https://drive.google.com/file/d/1rRF6ohhr1f2hhO3K_FHijVlUkwr54mWD/view?usp=drive_link">Slide</a> <br>
			 				"A method to cryptanalyze (Simultaneous) Conjugacy Search Problem in certain Metabelian Platform Groups"
						</li>
					</ul>
				</td>
			</tr>
			<tr><td colspan="2"><hr></td></tr><!------------------------------>
			<tr>
				<td class="schedule">13:30-14:30</td>
				<td><em>Lunch</em><br>
				</td>
			</tr>
			<tr><td colspan="2"><br></td></tr>

			<!---------------------------------------------------------------->

			<tr bgcolor="lightblue">
				<td class="schedule" colspan="2">
				  <font size="+1"><b>15 December (afternoon) - Scientific Session</b></font>
				</td>
			</tr>
			<tr><td colspan="2"><br></td></tr>
			<tr>
				<td class="schedule">14:30-16:30</td>
				<td>
					<b>Mini-session: Boolean functions and symmetric cryptography</b> - <a href="https://www.youtube.com/live/vsr5QpZT15I?si=GMGJwmnXQel7Dl3q">Video</a> <br>
				</td>
			</tr>
			<tr>
				<td class="schedule"></td>
				<td>
					<em><b>Invited Talk</b> - Svetla Petkova-Nikova (Katholieke Universiteit Leuven- Belgium) - Research Manager</em> - <a href="https://drive.google.com/file/d/1TVpnO7gqjzhdhRDhmkKyCyJSUIXAplqT/view?usp=drive_link">Slide</a> <br>
					"Threshold Implementations: Securing Implementations of Symmetric-Key Algorithms" - 
					<span
						class="popup"
						targetId="abstract7"
						(click)="openPopup($event)"
					>
						Abstract
						<span class="popuptext" id="abstract7">
							With the increase in portable devices performing cryptographic computations, physical attacks are becoming easy to execute. One of the most common physical attacks is Side-Channel Analysis (SCA), extremely dangerous due to its non-invasive nature. Threshold Implementations (TI) was proposed as the first countermeasure to provide provable security in masked hardware implementations. <br>
		 					In this lecture we will first introduce the method and give examples of HW implementations using Threshold Implementations. Then we will present the most recent developments in the theory and practice of Threshold Implementations and will demonstrate Tis providing various trade-offs and achieving efficiency and security of HW implementations.
						</span>
					</span>
				</td>
			</tr>
			<tr><td colspan="2"><br></td></tr>
			<tr>
				<td class="schedule"></td>
				<td>
					<em>Marco Calderini, Roberto Civino, Riccardo Invernizzi</em> - <a href="https://drive.google.com/file/d/1K_3d1kOG46m5fj76HmP1Ck_jPD__RE3H/view?usp=drive_link">Slide</a> <br>
					"Differential experiments using parallel alternative operations"
				</td>
			</tr>	
			<tr><td colspan="2"><br></td></tr>
			<tr>
				<td class="schedule"></td>
				<td>
					<em>Marine Minier, Loïc Rouquette and Christine Solnon</em> - <a href="https://drive.google.com/file/d/122Tgqx2HSRmASWG78bjchazny2EitEKn/view?usp=drive_link">Slide</a> <br>
					"Automatic Boomerang Attacks Search on Rijndael"
				</td>
			</tr>
			<tr><td colspan="2"><hr></td></tr><!------------------------------>
			<tr>
				<td class="schedule">16:30-17:00</td>
				<td><em>Coffee break</em></td>
			</tr>
			<tr><td colspan="2"><hr></td></tr><!------------------------------>
			<tr>
				<td class="schedule">17:00-18:30</td>
				<td><b>Mini-session: Cloud encryption</b><br></td>
			</tr> 
			<tr>
				<td class="schedule"></td>
				<td>
					<p>
						<em>Marco Calderini, Riccardo Longo, Massimiliano Sala,	Irene Villa</em> - <a href="https://drive.google.com/file/d/1wcZewmVXDJiHTJ4ZCPHK7KFrtuu5LtHL/view?usp=drive_link">Slide</a> <br>
						"Searchable Encryption with randomized ciphertext and randomized keyword search"
					</p>
				</td>
			</tr>
			<tr>
				<td class="schedule"></td>
				<td>
					<p>
						<em>Sigurd Eskeland</em> - <a href="https://drive.google.com/file/d/1Nq56jITkML4_ekCaijGXCL32QnwCV5q5/view?usp=drive_link">Slide</a> <br>
						"Cryptanalysis of a privacy-preserving authentication scheme based on private set intersection"
					</p>
				</td>
			</tr>
			<tr>
				<td class="schedule"></td>
				<td>
					<p>
						<em>Marco Cianfriglia, Elia Onofri, Marco Pedicini</em> - <a href="https://drive.google.com/file/d/1EjK83KKMWVUJ2uGYQeisNYbbDsbJfebs/view?usp=drive_link">Slide</a> <br>
						"mR_LWE-CP-ABE: a revocable CP-ABE for Post-Quantum Cryptography"
					</p>
				</td>
			</tr>
		</table>
	</div>
</div>